module.exports = __webpack_public_path__ + "static/media/cr90.d8b654a4.png";